export const buildAssignmentGroupColumns = (
  expectedCounts: Array<number | undefined>,
): number[][] => {
  const singletonIndexes = expectedCounts.flatMap((expected, index) =>
    expected === 1 ? [index] : [],
  )
  const shouldStack =
    expectedCounts.length >= 3 &&
    singletonIndexes.length >= 2 &&
    expectedCounts.some((expected) => (expected ?? 0) >= 4)

  if (!shouldStack) {
    return expectedCounts.map((_, index) => [index])
  }

  const columns: number[][] = []
  let insertedStack = false
  expectedCounts.forEach((expected, index) => {
    if (expected === 1) {
      if (!insertedStack) {
        columns.push(singletonIndexes)
        insertedStack = true
      }
      return
    }
    columns.push([index])
  })
  return columns
}
